import { Component, OnInit } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { MenuNode } from '../../../classes';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {
	node : MenuNode = undefined;
  	smallLetters : string="";
	bigLetters : string="";
	_unit : string = "";
	_gated:boolean=false;

	_overrideBigLetters:string="";
	_useOverride:boolean = false;
	_overrideUnit = '';
  constructor(
  	private navBar:NavBarService,
  	private iconBar:IconBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService,
  ) { }
  b():string{
  	//return this.bigLetters;
  	if(this._useOverride){
  		return this._overrideBigLetters;
  	}
  	return this.bigLetters;
  }
  unit():string{
  	if(this._useOverride){
  		return this._overrideUnit;
  	}
  	if(this._unit){
   		return this._unit;
   	}
   	return '';
  }
  s():string{
  	return this.smallLetters;
  }
  
  getIconBar(){
    return this.iconBar;
  }

  handler(evt):void{

  }

  _showScale:boolean=false;
  _scaleType:string="loadinganimation";
  
  scaleType(){
  	return this._scaleType;
  }
  
  showScale():boolean{
  	return this._showScale;
  }



  back(){
  	let targetNode = this.node.getBackTargetNode();
  	if(targetNode){
  		this.menuService.goto(targetNode);
  		return;
  	}
  	this.menuService.hierarchyUp();
  }


  hasParameter(p:string):boolean{
  	if(this.node){
  		return this.node.hasParameter(p);
  	}
  	return false;
  }
  subscription:any=undefined;
  ngOnDestroy(){
    this.customDestroy();
  }
  program : any = undefined;

  ngOnInit() {
	this.node = this.menuService.getCurrentNode();
  	if(this.node.hasProgram()){
  		this.program = this.node.getProgram();
  	}
  	this.program(this);
    this.iconBar.saveState('onMenuInit');
  	
  	this.subscription = this.ioService.inputs.events$.subscribe( (evt)=>{
  		this.handler(evt);
  	});
  }
  
  customDestroy(){
      //this.debug("#### OnDestroy, unsubscribing.");
      if(this.subscription){
      	this.subscription.unsubscribe();
      }
      //this.debug("#### OnDestroy, unsubscribed.");
      this.subscription = null;
      this.iconBar.restoreState('onToastEnter');
  }



}
